module.exports = __webpack_public_path__ + "static/media/24import-53.5cde713e.xlsx";